import * as React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Slider from "react-slick";
import { Container, textAlign } from '@mui/system';


interface MainFeaturedPostProps {
  post: {
    description: string;
    image: string;
    imageText: string;
    linkText: string;
    title: string;
  };
}

export default function MainFeaturedPost(props: MainFeaturedPostProps) {
  const { post } = props;
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    autoplay:true,
    autoplaySpeed:20000,
    slidesToScroll: 1,
  };
  return (
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 4,
        backgroundSize: 'cover',
      }}
    >
      <Slider {...settings}>
        <Box>
          <Grid container spacing={2} sx={{height:210,display: "flex",alignItems: "center",justifyContent: "center"}}>
            <Grid item xs={8}>
              <Typography component="h2" variant="body2">
                
              </Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography component="h2" variant="body2" style={{textIndent:"2em"}}>
                  开发微信公众号，小程序，微信支付的得力助手。在平台获取一个专属自己且支持HTTPS的域名，将该域名直接指向到你自己的开发电脑上。
                </Typography>
            </Grid>
          </Grid>
          </Box>
        <Box>
          <Grid container spacing={2} sx={{height:210,display: "flex",alignItems: "center",justifyContent: "center"}}>
            <Grid item xs={8}>
              <Typography component="h2" variant="body2">
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography component="h2" variant="body2" style={{textIndent:"2em"}}>
                如果你想通过公网访问搭建在你个人电脑上的网站。本平台将是你最好的选择。通过在本平台创建子域名，你可以随时随地访问你个人电脑上的网站。
                您不需要另外购买云服务器专门部署您的网站，直接用您的个人电脑即可。
              </Typography>
            </Grid>
          </Grid>
          </Box>
        <Box>
          <Grid container spacing={2} sx={{height:210,display: "flex",alignItems: "center",justifyContent: "center"}}>
            <Grid item xs={8}>
              <Typography component="h2" variant="body2">
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography component="h2" variant="body2" style={{textIndent:"2em"}}>
                想想，在家里的电脑上通过windows自带的远程桌面客户端 mstsc 即可访问您公司的电脑桌面，是不是一件很酷的事情。相反也是一样的，即从公司访问您家里电脑的桌面。
                使用我们平台提供的远程桌面转发通道，即可实现您多个电脑桌面之间的相互访问。您甚至不再需要百度网盘这样的工具，因为你已经可以做到随时随地访问自己各个电脑上文件。
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Slider>
    </Paper>
  );
}
